import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { HttpClient } from '@angular/common/http';


@IonicPage()
@Component({
  selector: 'page-program-phone-calls',
  templateUrl: 'program-phone-calls.html',
})
export class ProgramPhoneCallsPage {

  program_name: string = null;
  program_id: string = null;
  phonecalls: any[] = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider, private http: HttpClient) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramPhoneCallsPage');
    this.http.get('https://api.twilio.com/2010-04-01/Accounts/{AccountSid}/Recordings.json').toPromise().then(recordings => {
      console.log('Recordings: ', recordings);
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-phone-calls/program-phone-calls.ts